export default {"src":"/login-app/[GIT_HASH]/_next/static/media/no_access.e63a870a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};